/**
 * Register used for initializing integration services.
 */
/* @ngInject */
function integrationRegisterService ($q, IntegrationStoreService) {
  var api = {
    initialize: initialize
  }
  return api

  /**
     * Initializes all registered integration services.
     * @param {oParams} object - Parameter used on integration services.
     * @param {oParams.user} object - User data.
     * @param {oParams.company} object - Customer Company data.
     */
  function initialize (oParams) {
    var ops = []
    IntegrationStoreService.forEach(function (integrationService) {
      if (!integrationService.initialize) {
        throw new Error("Integration Service doesn't have 'initialize' function")
      }
      ops.push(integrationService.initialize(oParams))
    })
    return $q.all(ops)
  }
}

export { integrationRegisterService }
